import React from "react"
export function NoBaggage(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M17.943 1L19 2.06l-.956.954-12.96 12.959L2.055 19 1 17.946l2.326-2.326a1.162 1.162 0 01-.329-.812v-2.951h4.09l1.749-1.749H2.997V6.65c0-.643.522-1.165 1.165-1.165h2.643l.001-2.32c0-.644.522-1.166 1.165-1.166h4.078c.643 0 1.165.522 1.165 1.166v2.32h.246L17.943 1zm-6.63 10.856h5.666v2.952c0 .644-.522 1.166-1.165 1.166l-8.62-.001 4.12-4.117zM16.98 6.65v3.46H13.06l3.851-3.85c.043.123.067.254.067.39zm-5.514-2.903H8.553L8.55 5.483h2.913l.001-1.737z"
        fill="currentColor"
        id="prefix__no-baggage"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
